import { handleRequest } from './base';

const BusinessRepo = {
  all: () => handleRequest({
    method: 'get',
    url: '/business',
  }),
  fetch: (business_id) => handleRequest({
    method: 'get',
    url: `/business/${business_id}`,
  }),
};

export default BusinessRepo;
